import { useId } from 'react'
import { useHitTarget } from '../../platform/responsive/hitTarget'
import { DEFAULT_DAYS, localToday, longDate, windowStart } from './backfillWindow'

/**
 * The From field Apply now and Apply all rules share (rv-architect M4): label, date input and the
 * date read back in words, "Jul 14, 2026 · last 90 days" for the default.
 *
 * - An emptied field is no choice: it goes back to the default rather than an unbounded run.
 * - A future date becomes today.
 * - No 365-day floor: that is the builder backfill's server clamp (`backfill_start_date`). `/apply`
 *   and `/apply-all` take any `date_from`, and the 5,000-row cap is what bounds them.
 */
export function ApplyFromField({
  value,
  onChange,
  readOnly = false,
}: {
  value: string
  onChange: (from: string) => void
  /** Fixed: while a run is going, or while Apply all is continuing over this window. */
  readOnly?: boolean
}) {
  const today = localToday()
  const defaultFrom = windowStart(null, today)
  const h = useHitTarget('page')
  const id = useId()
  return (
    <div className="rule-apply__from">
      <label className="rule-past__label" htmlFor={id}>
        From
      </label>
      <input
        id={id}
        type="date"
        className="rule-control"
        style={{ minHeight: h }}
        max={today}
        value={value}
        readOnly={readOnly}
        aria-readonly={readOnly || undefined}
        onChange={(e) => onChange(e.target.value === '' ? defaultFrom : e.target.value > today ? today : e.target.value)}
        aria-describedby={`${id}-shown`}
      />
      <p id={`${id}-shown`} className="rule-past__hint">
        {longDate(value)}
        {value === defaultFrom ? ` · last ${DEFAULT_DAYS} days` : ''}
      </p>
    </div>
  )
}
